var _path, _polyline, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    color: "#2329D6",
    fill: "none",
    height: "48px",
    role: "img",
    stroke: "#2329D6",
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    viewBox: "0 0 24 24",
    width: "48px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "shareiOSIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,3 L12,15"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "9 5 12 2 15 5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 12,
    width: 12,
    x: 6,
    y: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOs);
export default __webpack_public_path__ + "static/media/iOS.009276fdd6edff946c636f4bfd052b21.svg";
export { ForwardRef as ReactComponent };